import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../auth/AuthContext';

function getVisitorId() {
  let id = localStorage.getItem('rn_vid');
  if (!id) {
    id = (window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now());
    localStorage.setItem('rn_vid', id);
  }
  return id;
}

export default function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    api.post('/track', { visitorId: getVisitorId(), path: pathname }).catch(() => {});
  }, [pathname]);
  return null;
}
